import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon-email"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 1000"
    >
      <path d="M958 185L540 524a67 67 0 0 1-81 0L40 185c-14-12-40-2-40 19v592a52 52 0 0 0 52 52h896a52 52 0 0 0 52-52V204c0-23-25-33-42-19zm-852 0l354 286a68 68 0 0 0 81 0l353-286c23-18 18-33-11-33H118c-29 0-34 15-12 33z" />
    </svg>
  );
}
